import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'atp-sign-accepted-dialog',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './atp-sign-accepted-dialog.component.html',
  styleUrl: './atp-sign-accepted-dialog.component.scss',
})
export class AtpSignAcceptedDialogComponent {
  @Input() active: boolean = false;
  @Input() documents: any = '';
  @Input() address: any = { streetAddress: '', cityStateZip: '' };
  @Input() modalHeaderTitle: string = '';
  @Input() modalBody: string = '';
  @Input() projectId: any = '';
  @Input() dashboard: boolean = false;
  @Input() siteVisitRequired: boolean = false;

  @Output() modalClosed = new EventEmitter<boolean>();

  closeDialog() {
    this.active = false;
    this.modalClosed.emit(this.active);
  }

  submit() {
    this.closeDialog();
  }
}
